<template>
  <div class="container">
    <div :style="{ width: width * 3 + 'px', textAlign: 'left', fontSize: '24px', margin: '15px 0' }">
      <span>课程页面轮播图</span>
    </div>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix" :style="{ width: width * 3 + 'px' }">
        <!-- <span>我的课程</span> -->
        <el-button style="float: right; margin-left: 15px;">还可设置{{ 5 - swiperList.length }}个</el-button>
        <el-button type="primary" style="float: right;" @click="dialogFormVisible=true">设置新的轮播图</el-button>
      </div>

      <el-table
        :data="swiperList"
        style="width: 100%">
        <el-table-column
          label="封面"
          class="course-cover"
          style="border: 1px solid green;"
          :width="width">
          <template slot-scope="scope">
            <img :style="{ width: width * 0.7 + 'px' }" v-if="scope.row" :src="imgDomain + scope.row.cover" />
            <!-- <el-button type="text" size="small">编辑</el-button> -->
          </template>
        </el-table-column>

        <el-table-column
          prop="title"
          label="课程"
          :width="width">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          :width="width">
          <template slot-scope="scope">
            <!-- <el-button @click="removeCourse(scope.row)" type="text" style="color: red;" size="small">删除</el-button> -->
            <el-button type="text" @click="cancelCourseSwiper(scope.row, scope.$index)" size="small">下线</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog title="设置新的轮播图" :visible.sync="dialogFormVisible">
        <el-form>
          <el-form-item label="课程" >
            <el-select v-model="course_id" placeholder="请选择课程">
              <template v-for="item of list">
                <el-option v-if="item.is_swiper === 0" :key="item.id"  :label="item.title" :value="item.id"></el-option>
              </template>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleAddSwiper">设为轮播图</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import api from '@/api'
import { imgDomain } from '@/config'
import { mapState } from 'vuex'

export default {
  name: 'MyCourse',
  data () {
    return {
      imgDomain,
      list: [],
      swiperList: [],
      width: (window.outerWidth - 350) / 3,
      user: {},
      dialogFormVisible: false,
      course_id: ''
    }
  },

  props: {
    msg: String
  },

  computed: {
    ...mapState([
      'series'
    ])
  },

  methods: {
    async getAllCourse () {
      try {
        const json = await api.getMyCourse()
        console.log(json, '输出结果')
        const list = json.data
        this.list = list
        this.swiperList = list.filter(item => item.is_swiper)
      } catch (e) {
        //
      }
    },

    async handleAddSwiper () {
      const id = this.course_id
      const swiper_index = 1
      console.log(id, 11111)
      if (!id) {
        return
      }

      const result = await api.editCourseSwiper(id, 1, swiper_index)
      if (result.ret !== 1000) {
        return
      }

      let course = {}
      let index = 0
      this.list.forEach((item, i) => {
        if (id === item.id) {
          index = i
          course = item
        }
      })

      this.swiperList.unshift(course)
      this.list.splice(index, 1)
      console.log(id, swiper_index)

      this.dialogFormVisible = false
    },

    async cancelCourseSwiper (row, index) {
      console.log(row, index)

      const id = row.id
      const swiper_index = 0
      console.log(id, 11111)
      if (!id) {
        return
      }

      const result = await api.editCourseSwiper(id, 0, swiper_index)
      if (result.ret !== 1000) {
        return
      }


      this.list.unshift(row)
      this.swiperList.splice(index, 1)
      console.log(id, swiper_index)

      this.dialogFormVisible = false
    },

    async updateSeries (row, index) {
      console.log(row, '犀利', index)
      const sid = row.sid
      const name = row.name

      this.$prompt('修改系列名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: name
      }).then(async ({ value }) => {
        if (!value) {
          return
        }

        this.$store.dispatch('updateSeries', {
          name: value,
          sid,
          index,
          that: this
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        })
      })
    },

    async addSeries () {
      this.$prompt('请输入系列名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async ({ value }) => {
        if (!value) {
          return
        }

        this.$store.dispatch('addSeries', {
          name: value,
          that: this
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        })
      })
    }
  },

  created () {
    this.getAllCourse()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.course-cover {
}
</style>
